import * as React from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";

// CSS
const useStyles = makeStyles((theme) => ({ }));

// All the incoming values
interface IProps {
    children?: React.ReactNode;
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch;
export const PageExplainText = (props: AllProps) => {
    const classes = useStyles(useTheme());
    return (<Typography variant="subtitle1" gutterBottom>{props.children}</Typography>)
}